import type { ComponentProps } from "react";

export function Input({ className = "", ...props }: ComponentProps<"input">) {
  return (
    <input
      className={`w-full bg-rs-black text-white border border-rs-jet-light rounded-[5px] px-[11px] py-[10px] text-sm leading-[1.35] [color-scheme:dark] hover:border-[#3c4235] focus:border-rs-green focus:outline-none ${className}`}
      {...props}
    />
  );
}
